import { isIsoDate } from '../validation/is-iso-date.function';
import { isIsoDateTime } from '../validation/is-iso-date-time.function';
import { isIsoDateTimeTz } from '../validation/is-iso-date-time-tz.function';
import type { IsoDate, IsoDateTime, IsoDateTimeTz } from '../../types/iso-date';
import { deconstructDate } from '../helper/deconstruct-date.function';

/**
 * Returns the weekday number using JavaScript convention: Sunday = 0 .. Saturday = 6.
 *
 * Supported inputs:
 * - Date-only: YYYY-MM-DD
 * - Date-time (no tz): YYYY-MM-DDTHH:mm:ss(.fraction[1-6])?
 * - Date-time with tz: YYYY-MM-DDTHH:mm:ss(.fraction[1-6])?(Z|±HH:MM)
 *
 * Calculation uses UTC and the calendar date portion (YYYY-MM-DD) for determinism.
 */
export function getWeekday(input: IsoDate | IsoDateTime | IsoDateTimeTz): number {
  const {year, month, day} = deconstructDate(input);
  if(!year || !month || !day)
    throw new Error('getWeekday: invalid ISO date/date-time string');

  // UTC to avoid environment timezone differences
  const date = new Date(Date.UTC(year, month - 1, day));
  return date.getUTCDay(); // 0=Sun..6=Sat
}

